import React from "react";
import { KIT_ROWS, KIT_INCLUDES } from "../../data/content";
import { CheckIcon, XIcon } from "lucide-react";
export function KitComparison() {
  return <section className="bg-black py-16 px-4" data-id="element-152" data-mp="2so4ry24d4o5l">
      <div className="max-w-5xl mx-auto" data-id="element-153" data-mp="37f40jd577cp6">
        <h2 className="font-display text-3xl sm:text-4xl text-white text-center uppercase mb-2" data-id="element-154" data-mp="37gyj4kszysq3">
          🕊️ ¿Qué agrega el Kit Escalamiento y Marca Personal?
        </h2>
        <p className="text-center text-neutral-500 text-sm mb-8 md:hidden" data-id="element-155" data-mp="3ge8t82u2wbtf">← Deslizá para ver la tabla completa →</p>

        <div className="overflow-x-auto hide-scrollbar rounded-2xl border border-neutral-800" data-id="element-156" data-mp="3bg7f7wbif2ot">
          <table className="w-full min-w-[640px] text-sm" data-id="element-157" data-mp="3qcyem5l6oeef">
            <thead data-id="element-158" data-mp="3ledf68dr9yr1">
              <tr className="bg-neutral-950 text-left" data-id="element-159" data-mp="3lfy7rsgif7m9">
                <th className="p-4 font-condensed text-lg text-white tracking-wide" data-id="element-160" data-mp="1vzf8i7d37nhi">Situación en tu negocio</th>
                <th className="p-4 font-condensed text-lg text-neutral-400 tracking-wide" data-id="element-161" data-mp="1r15c5tfmmgub">❌ Sin Kit PRO</th>
                <th className="p-4 font-condensed text-lg text-[#e10600] tracking-wide" data-id="element-162" data-mp="1erwr3x0tlg6t">✅ Con Kit PRO</th>
              </tr>
            </thead>
            <tbody data-id="element-163" data-mp="1iqmb48gd5vzf">
              {KIT_ROWS.map((r, i) => <tr key={i} className={i % 2 ? "bg-black" : "bg-neutral-950/50"} data-id="element-164" data-mp="1nqqrzzl6osq6" data-mpi={i}>
                  <td className="p-4 text-neutral-300 align-top" data-id="element-165" data-mp="1sj1pywwd64g3">{r.situation}</td>
                  <td className="p-4 text-neutral-500 align-top" data-id="element-166" data-mp="1xhv7d0eruflj">
                    <span className="flex items-start gap-2" data-id="element-167" data-mp="1xjpi5lwbwrbw">
                      <XIcon className="w-4 h-4 text-neutral-600 mt-0.5 flex-shrink-0" data-id="element-168" data-mp="22fn0fxr5k7rb" />
                      {r.without}
                    </span>
                  </td>
                  <td className="p-4 text-white align-top" data-id="element-169" data-mp="2bh4b30lsjh8m">
                    <span className="flex items-start gap-2" data-id="element-170" data-mp="2bgl249e4c36q">
                      <CheckIcon className="w-4 h-4 text-[#e10600] mt-0.5 flex-shrink-0" data-id="element-171" data-mp="c5bo7wspvs9m" />
                      {r.with}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="mt-12 bg-neutral-950 border border-neutral-800 rounded-2xl p-6 sm:p-8" data-id="element-172" data-mp="1kg3o1suu27n9">
          <h3 className="font-condensed text-2xl text-[#e10600] tracking-wide mb-6 text-center" data-id="element-173" data-mp="1fhipryz55y1g">
            ✅ El Kit Maestro PRO incluye:
          </h3>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-174" data-mp="1of2szdgke4ep">
            {KIT_INCLUDES.map(k => <li key={k.title} className="flex items-start gap-3" data-id="element-175" data-mp="23c3citolqt23">
                <CheckIcon className="w-5 h-5 text-[#e10600] mt-1 flex-shrink-0" data-id="element-176" data-mp="1yea7w52y673x" />
                <div data-id="element-177" data-mp="2c5f8b9e533fb">
                  <span className="text-white font-semibold" data-id="element-178" data-mp="2c5yextyca5e1">{k.title}</span>
                  <span className="text-neutral-400" data-id="element-179" data-mp="283tmuznjhgti"> — {k.desc}</span>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}